import { SCENE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: `${SCENE_MNG}/relateFeature`,
  params: null,
  extraParams: null,
  okAction: 'create',
  formatData(data) {
    data.sceneId = this.extraParams?.sceneId
    const relateFeatureArr = data.relateFeatureArr.map(item => {
      return item.id
    })
    data.relateFeatureArr = relateFeatureArr
    return data
  },
  view: {
    title: '关联功能',
    labelPosition: 'right',
    content: [
      {
        $id: 'relateFeatureArr',
        label: '关联功能',
        $type: 'sky-relation-option',
        actions: {
          nativeOn: {
            click: 'RelationFeature'
          }
        },
        $el: {
          multiple: true
        }
      }
    ]
  }
}
